import { createContext } from 'react';

export const AppContext = createContext( null );

export const MapContext = createContext( null );

export const ChartsContext = createContext( null );

export default AppContext;